import {SortActionsUnion, SortActionTypes} from '~app/modules/brand-plp/store/sort/sort.actions';
import {sortInitialState} from '~app/modules/brand-plp/store/sort/sort.state';
import { SortTypes } from '~shared/modules/application-event/models/sort-option.model';

export function sortReducer(state = sortInitialState, action: SortActionsUnion) {
  switch (action.type) {
    case SortActionTypes.SET_SORT:
    case SortActionTypes.SET_SORT_WITHOUT_NAVIGATION:
      const newSortingOption = action.payload;
      const newSort = SortTypes.find(({ code }) => code === newSortingOption);

      return newSort
        ? { ...state, sortOption: newSort }
        : state;
    default:
      return state;
  }
}
